export default "__VITE_ASSET__CPKf$qCS__"